import classes from "./OurStrategy.module.scss";
import InfoCards from "../InfoCards/InfoCards";
import { ReactComponent as Scability } from "../../../assets/icons/clemAi/scalability.svg";
import { ReactComponent as Economics } from "../../../assets/icons/clemAi/economics.svg";
import { ReactComponent as Reliability } from "../../../assets/icons/clemAi/reliability.svg";

function OurStrategy() {
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        Our <br /> <span>Strategy</span>
      </div>

      <p className={classes.description}>
        CLEM.ai <span>leverages AI</span> to provide the most efficient and{" "}
        <span>cost effective clean energy mix</span> for any demand center based
        on its latitude and longitude.
      </p>

      <div className={classes["outer"]}>
        <div className={classes["middle"]}>
          <div className={classes["inner"]}>Optimal clean energy blend</div>
        </div>
      </div>

      <InfoCards
        content={[
          {
            title: "Scalability",
            icon: <Scability />,
          },
          {
            title: "Economical",
            icon: <Economics />,
          },
          {
            title: "Reliability",
            icon: <Reliability />,
          },
        ]}
      />
    </div>
  );
}

export default OurStrategy;
